import React from 'react'

import type { ReactNode } from 'react'
import * as S from './styled'

type DivisionProps = {
  size?: 'small' | 'medium' | 'large'
  children?: ReactNode
}

export const Division = ({ size = 'medium', children }: DivisionProps) => {
  return <S.Container $size={size}>{children}</S.Container>
}
